import React, { useEffect, useRef } from "react";

const helpSections = [
  {
    title: "Shortcuts",
    items: [
      ["Undo/Redo", "Ctrl/Cmd+Z or Ctrl/Cmd+Shift+Z"],
      ["Eraser", "Right Click + Drag"],
      ["Rotate Arrow", "Shift + Left Click"]
    ],
  },
  {
    title: "Whiteboard Tools",
    items: [
      ["Player Paths", "Using the pencil tool, start drawing on a player arrow. Resulting dotted line will represent a path the arrow will follow when play button is pressed."],
      ["Play / Pause", "Play moves player arrows along their drawn paths; Pause stops the playback."],
      ["Export", "Download an image of the current whiteboard state."],
      ["Clear", "Clear all drawings from the whiteboard."],
    ],
  },
  {
    title: "R6 Help",
    items: [
      ["Change Operator", "Right click on any operator icon to change the operator or outline colour."],
      ["Change Utility Colour/Number", "Right click on the number beside the utility icon to change the assigned number or outline colour."],
      ["Delete Utility", "Right click on the utility icon to delete it."],
    ],
  }
];

const HelpModal = ({ visible, onClose }) => {
  const closeButtonRef = useRef(null);

  useEffect(() => {
    if (!visible) return undefined;

    closeButtonRef.current?.focus();
    const handleKeyDown = (event) => {
      if (event.key === "Escape") onClose();
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [visible, onClose]);

  if (!visible) return null;

  return (
    <div
      onMouseDown={(event) => {
        if (event.target === event.currentTarget) onClose();
      }}
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 1100,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 24,
        background: "rgba(0, 0, 0, 0.72)",
      }}
    >
      <section
        role="dialog"
        aria-modal="true"
        aria-labelledby="help-modal-title"
        style={{
          position: "relative",
          width: "min(720px, 100%)",
          maxHeight: "100%",
          overflowY: "auto",
          boxSizing: "border-box",
          padding: 28,
          color: "#f5f5f5",
          textAlign: "left",
          background: "#17191d",
          border: "1px solid #444",
          borderRadius: 8,
          boxShadow: "0 12px 36px rgba(0, 0, 0, 0.6)",
        }}
      >
        <button
          ref={closeButtonRef}
          type="button"
          aria-label="Close help"
          onClick={onClose}
          style={{
            position: "absolute",
            top: 16,
            left: 16,
            display: "flex",
            width: 40,
            height: 40,
            alignItems: "center",
            justifyContent: "center",
            padding: 8,
            color: "#fff",
            background: "#25272c",
            border: "1px solid #555",
            borderRadius: 6,
            cursor: "pointer",
          }}
        >
          <img
            src="/icons/Chevron.png"
            alt=""
            style={{ width: 22, height: 22, objectFit: "contain" }}
          />
        </button>
        <h2 id="help-modal-title" style={{ margin: "0 0 24px", textAlign: "center" }}>
          TacMaps Help
        </h2>
        {helpSections.map((section, index) => (
          <section key={section.title} aria-labelledby={`help-section-${index}`}>
            <h3 id={`help-section-${index}`} style={{ margin: "20px 0 8px", textAlign: "center" }}>
              {section.title}
            </h3>
            <dl style={{ margin: 0 }}>
              {section.items.map(([tool, description]) => (
                <div
                  key={tool}
                  style={{
                    display: "grid",
                    gridTemplateColumns: "minmax(130px, 1fr) 3fr",
                    gap: "8px 16px",
                    padding: "8px 0",
                    borderBottom: "1px solid #303238",
                  }}
                >
                  <dt style={{ fontWeight: 700 }}>{tool}</dt>
                  <dd style={{ margin: 0, color: "#c5c8cf", lineHeight: 1.5 }}>
                    {description}
                  </dd>
                </div>
              ))}
            </dl>
        </section>
      ))}
      </section>
    </div>
  );
};

export default HelpModal;
